<template>
  <div class="card">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="讲解" name="first" v-if="userMess.applyPost==1||userMess.applyPost==3">
        <el-select v-model="explain" placeholder="请选择">
          <el-option v-for="item in explainHallList" :key="item.id" :label="item.exhibitionHallName" :value="item.id"></el-option>
        </el-select>
        <!-- <e-calendar :calendar-data="ecalendarData" @sign-up="signupExplain(arguments)"></e-calendar> -->
        <ul class="calendar-j mat10">
          <li v-for="item in jCalendarData">
            <div class="head">{{item.explainDate|dateFilter}}</div>
            <template v-if="item.explainInfoList">
              <div class="main">
                <div>
                  <div class="item" :title="cItem.volunteerName" v-for="cItem in item.explainInfoList">
                    <span class="time"> {{cItem.explainTime}}</span>
                    <span class="name">{{cItem.volunteerName}}</span>
                  </div>
                </div>
                <el-button type="primary" size="mini" class="sign-but" style="width:100px;" @click="signupExplain(['explain',true,item])" v-if="item.status==0">报名</el-button>
                <el-button type="info" size="mini" class="sign-but" style="width:100px;" @click="signupExplain(['explain',false,item])" v-if="item.status==1">查看</el-button>
              </div>
            </template>
            <template v-else>
              <div style="text-align:center;line-height:100px">暂无活动</div>
            </template>

          </li>
        </ul>
      </el-tab-pane>

      <el-tab-pane label="服务" name="second" v-if="userMess.applyPost==1||userMess.applyPost==3||userMess.applyPost==2">
        <ul class="calendar-f mat10">
          <li>
            <div class="container">
              <div class="head">时段/时间</div>
              <div class="main">
                <div>上午</div>
                <div>（9:00-12：00）</div>
              </div>
            </div>
            <div class="container">
              <div class="main">
                <div>下午</div>
                <div>（12:00-16:15）</div>
              </div>
            </div>
          </li>
          <li v-for="item in fCalendarData">
            <div class="container">
              <div class="head">{{item.serviceDate|dateFilter}}</div>
              <template v-if="item.serviceInfoList">
                <div class="main">
                  <div class="item" v-if="item.serviceInfoList[0].volunteerName!==null">
                    <div v-for="(ccItem,ccIndex) in item.serviceInfoList[0].volunteerName.split(',')" v-if="ccIndex<5">{{ccItem}}</div>
                    <div v-show="item.serviceInfoList[0].volunteerName.split(',').length>5" class="more">更多>></div>
                  </div>
                </div>
                <el-button type="primary" size="mini" style="width:100px;margin-top:30px" @click="signupExplain(['service',true,item,'am'])" v-if="item.serviceInfoList[0].status==0">报名</el-button>
                <el-button type="info" size="mini" style="width:100px;margin-top:30px" @click="signupExplain(['service',false,item,'am'])" v-if="item.serviceInfoList[0].status==1">查看</el-button>
              </template>
              <template v-else>
                <div class="none">暂无场次</div>
              </template>
            </div>
            <div class="container">
              <template v-if="item.serviceInfoList">
                <div class="main">
                  <div class="item" v-if="item.serviceInfoList[1].volunteerName!==null">
                    <div v-for="(ccItem,ccIndex) in item.serviceInfoList[1].volunteerName.split(',')" v-if="ccIndex<5">{{ccItem}}</div>
                    <div v-show="item.serviceInfoList[1].volunteerName.split(',').length>5" class="more">更多>></div>
                  </div>
                </div>
                <el-button type="primary" size="mini" style="width:100px;margin-top:30px" @click="signupExplain(['service',true,item,'pm'])" v-if="item.serviceInfoList[1].status==0">报名</el-button>
                <el-button type="info" size="mini" style="width:100px;margin-top:30px" @click="signupExplain(['service',false,item,'pm'])" v-if="item.serviceInfoList[1].status==1">查看</el-button>
              </template>
              <template v-else>
                <div class="none">暂无场次</div>
              </template>
            </div>
          </li>
        </ul>
        <!-- <s-calendar :calendar-data="scalendarData" @sign-up="signupExplain(arguments)"></s-calendar> -->
      </el-tab-pane>

      <el-tab-pane label="策划" name="third">
        <el-input v-model="planSearch" placeholder="请输入活动名称或活动编号" style="width:300px" size="small"></el-input>
        <el-button type="primary" size="small" @click="getPlanList({ currentPage: 1, pageSize: 10 })">搜索</el-button>
        <list :plan-list="planList" name="策划" :total="planTotal" @get-list="getPlanList"></list>
      </el-tab-pane>
      <el-tab-pane label="其他活动" name="fourth">
        <el-input v-model="activitySearch" placeholder="请输入活动名称或活动编号" style="width:300px" size="small"></el-input>
        <el-button type="primary" size="small" @click="getActivityList({ currentPage: 1, pageSize: 10 })">搜索</el-button>
        <list :plan-list="activityList" name="其他活动" :total="activityTotal" @get-list="getActivityList"></list>
      </el-tab-pane>
    </el-tabs>
    <!-- 讲解报名、查看详情弹框 -->
    <e-signup :dialog-visible="edialogVisible" @on-close="closeDialog(arguments)" :edit="edit" @on-submit="getDialog(arguments)" :title="edit?'报名':'详情'" :current-content="currentContent"></e-signup>
    <!-- 服务报名、查看详情弹框 -->
    <s-signup :dialog-visible="sdialogVisible" @on-close="closeDialog(arguments)" :edit="edit" @on-submit="getDialog(arguments)" :title="edit?'报名':'详情'" :current-content="currentContent"></s-signup>
  </div>
</template>

<script>

import eSignup from '@/components/modal/signup-explain.vue'
import sSignup from '@/components/modal/signup-service.vue'
import eCalendar from './components/calendar/ecalendar.vue'
import sCalendar from './components/calendar/scalendar.vue'
import list from './components/list/list.vue'
import { getSevenDay, formatDate } from '@/libs/utils'
export default {
  components: {
    eSignup,
    sSignup,
    eCalendar,
    sCalendar,
    list
  },
  data() {
    return {
      jCalendarData: [],
      fCalendarData: [],
      activeName: '',
      explainHallList: [],
      explain: '',
      edialogVisible: false,
      sdialogVisible: false,
      edit: false,
      currentContent: {},
      planList: [],
      activityList: [],
      planSearch: "",
      activitySearch: "",
      activityTotal: 0,
      planTotal: 0,
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {
    explain() {
      //改变展厅获取展厅信息
      this.getExplainList()
    }
  },
  methods: {
    //获取策划列表
    getPlanList(obj) {
      // console.log(obj)
      let params = {
        pageNumber: obj.currentPage,
        pageSize: obj.pageSize,
        searchKey: this.planSearch,
        status: 0,  // 状态 0/null全部 1招募中 2已结束 ,
        type: 1,  //类型 1策划 2其他活动 ,
        volunteerId: this.userMess.id
      }
      this.$api.getActivityList(params).then(res => {
        // console.log(res.data.rows)
        this.planList = res.data.rows
        this.planTotal = res.data.total
      })
    },
    //获取其他活动列表
    getActivityList(obj) {
      // console.log(obj)
      let params = {
        pageNumber: obj.currentPage,
        pageSize: obj.pageSize,
        searchKey: this.activitySearch,
        status: 0,  // 状态 0/null全部 1招募中 2已结束 ,
        type: 2,  //类型 1策划 2其他活动 ,
        volunteerId: this.userMess.id
      }
      this.$api.getActivityList(params).then(res => {
        // console.log(res)
        this.activityList = res.data.rows
        this.activityTotal = res.data.total
      })
    },

    handleClick(tab, event) {
      // console.log(tab, event);
    },
    //点击报名显示弹框
    signupExplain(array) {
      /** 
       * array[0] 所选弹框类型
       * array[1] 编辑还是查看
       * array[2] 所选的日期
       * type [explain]讲解,
       *      [service]服务
      */
      // console.log(array)
      let type = array[0];
      let edit = array[1];
      let data = array[2];

      this.edit = edit


      // 弹框显示
      if (type == "explain") {
        this.currentContent = data
        this.edialogVisible = true;

      }
      else if (type == "service") {

        let time = array[3]
        if (time == 'am') this.currentContent = { serviceDate: data.serviceDate, serviceInfoList: data.serviceInfoList[0] }
        else if (time == 'pm') this.currentContent = { serviceDate: data.serviceDate, serviceInfoList: data.serviceInfoList[1] }
        // console.log(this.currentContent)
        this.sdialogVisible = true
      }

    },
    //获取弹框内所填信息
    getDialog(array) {
      /** 
      * array[0] 所选弹框类型
      * array[1] 弹框携带的返回1数据
      * type [explain]讲解,
      *      [service]服务
     */
      let type = array[0];
      let data = array[1];
      // console.log(array)
      if (type == "explain") {
        let params = {
          activityType: '1',
          ids: data.checkList.toString(),
          volunteerId: this.userMess.id
        }
        this.$api.drawTask(params).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message);
            this.getExplainList()
            this.edialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        })
        // 
      }
      else if (type == "service") {
        let params = {
          activityType: '2',
          ids: data.checkList.toString(),
          volunteerId: this.userMess.id
        }
        // console.log(params)
        this.$api.drawTask(params).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message);
            this.getServiceList()
            this.edialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        })
      }
    },
    // 关闭弹框
    closeDialog() {
      this.edialogVisible = false
      this.sdialogVisible = false
    },
    //获取已解锁展厅
    getMyHall() {
      this.$api.unlockExhibitionHallData({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res)
        this.explainHallList = res.data
        this.explain = res.data[0].id
        //获取讲解信息
        // this.getExplainList()
      })
    },
    //获取讲解信息
    getExplainList() {
      let endTime = Date.parse(new Date()) + 6 * 24 * 60 * 60 * 1000
      let params = {
        startTime: formatDate(new Date(), 3),
        endTime: formatDate(endTime, 3),
        exhibitionHallId: this.explain
      }
      this.$api.getExplainSignStatus(params).then(res => {
        // console.log(res)
        this.jCalendarData = res.data
        // this.explainHallList = res.data
        // this.explain = res.data[0].id
      })
    },
    //获取服务信息
    getServiceList() {
      let endTime = Date.parse(new Date()) + 6 * 24 * 60 * 60 * 1000
      let params = {
        startTime: formatDate(new Date(), 3),
        endTime: formatDate(endTime, 3),
        volunteerId: this.userMess.id
      }
      this.$api.getServiceSignStatus(params).then(res => {
        // console.log(res)
        this.fCalendarData = res.data
        res.data.map(item => {
          // console.log(item.serviceInfoList[0].volunteerName.split(','))
        })
        // this.explainHallList = res.data
        // this.explain = res.data[0].id
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let date = new Date()

    // this.jCalendarData = getSevenDay()

    //
    this.getPlanList({ currentPage: 1, pageSize: 10 })
    //判断什么岗位，tag显示
    if (this.userMess.applyPost == 1) {
      this.activeName = "first"
      //获取已解锁展厅
      this.getMyHall()

    } else if (this.userMess.applyPost == 2) {
      this.activeName = "second"
      // this.getServiceList()
    }
    else if (this.userMess.applyPost == 3) {
      this.activeName = "first"
      //获取已解锁展厅
      this.getMyHall()
    }

    this.getActivityList({ currentPage: 1, pageSize: 10 })
    this.getServiceList()



  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  filters: {
    dateFilter: (val) => {
      let date = val.split('-')
      let res = date[0] + '年' + date[1] + '月' + date[2] + '日'
      return res
    }
  }
};
</script>
<style lang="less" scoped>
.calendar-j {
  display: flex;
  li {
    border: 1px solid #ebeef5;
    // flex: 1 1 auto;
    padding: 0 0 10px 0;
    width: 14.2%;
    .head {
      padding: 6px 0;
      background: #f7f8fb;
      border-bottom: 1px solid #ebeef5;
      text-align: center;
    }
    .main {
      position: relative;
      padding: 6px 12px 70px;
      text-align: center;
      height: calc(100% - 30px);
      .sign-but {
        position: absolute;
        bottom: 20px;
        left: calc(50% - 50px);
      }
      .item {
        display: flex;
        align-items: center;
        .time {
          display: inline-block;
          width: 40px;
          text-align: right;
        }
        .name {
          display: inline-block;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: calc(100% - 60px);
          margin-left: 10px;
        }
      }
    }
  }
}
.calendar-f {
  display: flex;
  li {
    width: 14.2%;
    .container {
      border: 1px solid #ebeef5;
      // flex: 1 1 auto;
      padding: 0 0 10px 0;

      height: 320px;
      text-align: center;
    }
    .none {
      line-height: 260px;
    }
    .head {
      padding: 6px 0;
      background: #f7f8fb;
      border-bottom: 1px solid #ebeef5;
      text-align: center;
    }
    .main {
      padding: 6px 12px;
      text-align: center;
      height: 200px;
      .item {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }

      .more {
        margin-top: 10px;
        font-size: 14px;
        color: @font-blue;
        cursor: pointer;
      }
    }
  }
}
</style>
